<template>
  <v-sheet
    rounded
    class="loginCard"
    min-width="450px"
    color="white"
    elevation="12px"
  >
    <slot></slot>
  </v-sheet>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.loginCard {
  padding: 42px 52px;
}
</style>
